import React from "react";
import { Input, FormGroup, Label, Col, Container, Row, FormText, Button } from "reactstrap";
import { appConstants } from "../../_constants";
import { FaBook, FaDownload, FaFile } from "react-icons/fa";
import { appHelpers } from "../../_helpers";
import FileIcon from "../../assets/images/icons/custom-file-icon.svg";
import "./index.scss";

const ViewTemplate = ({ record, handleChange, Comment, payload, componentErrorMessages }) => {
  if (!payload) return;
  const payloadKeys = Object.keys(payload);

   
  return (
    <Container>
      <Row>
        {payloadKeys.map((item, key) => (
          <>
            <Col sm="6" key={key}>
              <FormGroup className="mb-4">
                <Label>{item}</Label>
                <Input type="text" disabled value={payload[item]} />
              </FormGroup>
            </Col>
            
            {/* To view and download file  */}
            {item === "PaymentEvidenceUrl" && (
              <div className="file-wrapper">
                <div className="file-icon-wrapper">
                  <div className="file-icon">
                    <img src={FileIcon} alt="file" />
                  </div>
                  <p>{appHelpers.getFileNameFromUrl(payload[item])}</p>
                </div>

                <a href={payload[item]} target="_blank" download>
                  {/* <Button icon={<DownloadIcon />} >Download file</Button> */}
                  <Button className={"download__button--pdf btn-rounded btn-info"}>
                    Download file <FaDownload />
                  </Button>
                </a>
              </div>
            )}
          </>
        ))}

        

        {record.statusId !== appConstants.MAKER_CHECKER_STATUS.PENDING && (
          <Col sm="12">
            <FormGroup className="mb-4">
              <Label>Comment</Label>
              <Input type="text" disabled value={record.Comment} name="Comment" />
            </FormGroup>
          </Col>
        )}
        {record.statusId === appConstants.MAKER_CHECKER_STATUS.PENDING && (
          <Col sm="12">
            <FormGroup className="mb-4">
              <Label>Comment</Label>
              <Input type="text" value={Comment} name="Comment" onChange={handleChange} />

              {!Comment.trim() && <FormText color="danger">Comment is required.</FormText>}
            </FormGroup>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default ViewTemplate;
